import React from 'react';
import Image from '@sparefoot/react-core/Image';
import EmptyStar from 'assets/images/icons/empty-star.svg';
import states from 'config/states';

import Star from '../components/svg/Star';

export function getInitials(name) {
	const nameParts = name.split(' ');
	const firstNameInitial = nameParts[0] ? nameParts[0][0] : '';
	const lastNameInitial = nameParts[1] ? nameParts[1][0] : '';

	if (!firstNameInitial && !lastNameInitial) {
		return '';
	}

	if (name.length === 2) {
		return name.substring(0, 2).toUpperCase();
	}

	return (
		(firstNameInitial.toUpperCase() || '') +
		(lastNameInitial.toUpperCase() || '')
	);
}

export const generateStars = (stars, width, height, fillColor) => {
	const starsArray = [];

	for (let i = 1; i <= 5; i += 1) {
		if (i <= stars) {
			starsArray.push(
				<Star
					width={width}
					height={height}
					fillColor={fillColor}
				/>,
			);
		} else if (i - 0.5 === stars) {
			starsArray.push(
				<Star
					value={0.5}
					width={width}
					height={height}
					fillColor={fillColor}
				/>,
			);
		} else {
			starsArray.push(
				<Image
					src={EmptyStar}
					key={i}
					className="empty-star-svg"
					alt="empty star rating"
				/>,
			);
		}
	}

	return starsArray.map((star) => star);
};

export const stateAbbreviationToFullName = (abbreviation) =>
	states[abbreviation?.toUpperCase()]?.toLowerCase() || null;

// Utility to normalize storage type strings for PLP
// Ensures all types are lowercase and trims whitespace
export function normalizeStorageType(type) {
	if (!type || typeof type !== 'string') return '';
	return type.trim().toLowerCase();
}

// Utility to title-case a string (e.g., 'rv' -> 'RV', 'boat' -> 'Boat')
// Accepts an optional exceptions map for special casing (e.g., { rv: 'RV' })
export function toTitleCase(str, exceptions = { rv: 'RV' }) {
	if (!str) return '';
	return str
		.split(' ')
		.map((word) => {
			const lower = word.toLowerCase();
			if (exceptions[lower]) {
				return exceptions[lower];
			}
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		})
		.join(' ');
}

// Formats a number compactly (e.g., 1500 -> "1K", 2000000 -> "2M")
export function formatCountCompact(count) {
	const num = Number(count) || 0;
	if (num < 1000) return String(num);
	if (num < 1_000_000) return `${Math.floor(num / 1000)}K`;
	if (num < 1_000_000_000) return `${Math.floor(num / 1_000_000)}M`;
	return `${Math.floor(num / 1_000_000_000)}B`;
}
